import { call, put, takeEvery } from "redux-saga/effects";
import { toast } from "react-toastify";
import { createCandidateUser } from "@workspace/settings/src/helpers/backend_helper";
import { getPublicCandidateByEmail } from "@workspace/portfolio/src/helpers/backend_helper";
import {
  createCandidateUserFailure,
  createCandidateUserSuccess,
  fetchCandidateByEmailFailure,
  fetchCandidateByEmailSuccess,
} from "./action";
import { CREATE_CANDIDATE_USER, FETCH_CANDIDATE_BY_EMAIL } from "./actionType";

function* workCreateCandidateUser(action) {
  const { newUser, navigate } = action.payload;
  try {
    const userResponse = yield call(createCandidateUser, newUser);
    yield put(createCandidateUserSuccess(userResponse.data));
    navigate("/candidate/login");
    toast.success(userResponse?.message);
  } catch (error) {
    yield put(createCandidateUserFailure(error));
    if (error?.message?.includes("409")) {
      toast.error("Candidate already exists!");
      return;
    }
    toast.error(error?.message);
  }
}

function* workFetchCandidateByEmail(action) {
  const { email } = action.payload;
  try {
    const candidateResponse = yield call(getPublicCandidateByEmail, email);
    yield put(fetchCandidateByEmailSuccess(candidateResponse.data));
  } catch (error) {
    yield put(fetchCandidateByEmailFailure(error));
    toast.error(error?.message);
  }
}

export default function* watchFetchUserSaga() {
  yield takeEvery(CREATE_CANDIDATE_USER, workCreateCandidateUser);
  yield takeEvery(FETCH_CANDIDATE_BY_EMAIL, workFetchCandidateByEmail);
}
